<template>
  <main class="docs-page">
    <p v-if="loading" class="status-message">Carregando documentação...</p>
    <p v-if="error" class="status-message error-message">{{ error }}</p>
    <div ref="swaggerContainer" class="docs-container"></div>
  </main>
</template>

<script>
import axios from "axios";
import SwaggerUIBundle from "swagger-ui-dist/swagger-ui-bundle";
import "swagger-ui-dist/swagger-ui.css";
import { config } from "@/config";
import { getAccessToken } from "@/interceptors/axios";

export default {
  name: "DocsPage",
  data() {
    return {
      loading: true,
      error: "",
    };
  },
  async mounted() {
    try {
      const { data: openApiSpec } = await axios.get(`${config.API}/openapi.json`);

      openApiSpec.servers = [{ url: config.API }];

      SwaggerUIBundle({
        domNode: this.$refs.swaggerContainer,
        spec: openApiSpec,
        presets: [SwaggerUIBundle.presets.apis],
        requestInterceptor: async (request) => {
          const token = await getAccessToken();

          if (token) {
            request.headers = request.headers || {};
            request.headers.Authorization = `Bearer ${token}`;
          }

          return request;
        },
      });
    } catch (error) {
      this.error = `Não foi possível carregar a documentação: ${
        error?.message || error
      }`;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
.docs-page {
  min-height: 100vh;
  background-color: #fff;
}

.docs-container {
  min-height: 100vh;
  background-color: #fff;
}

.status-message {
  margin: 0;
  padding: 24px;
  font-family: Arial, sans-serif;
}

.error-message {
  color: #b42318;
}
</style>
